
export const LINKS = {
  HIVE_SIGNUP: 'https://ecency.com/signup?referral=cryptoshots.nft',
  KEYCHAIN_INSTALL: 'https://chrome.google.com/webstore/detail/hive-keychain/jcacnejopjdphbnjgfaaobbfafkihpep?hl=en',
};

export const ICONS = {
  DOOR_LOGIN: 'https://www.glyphicons.com/img/glyphicons/basic/2x/glyphicons-basic-431-log-in@2x.png',
};
